import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "source", "button", "icon"]
  static outlets = ["pdf-viewer"]
  static values = {
    param: { type: String, default: "view_mode" }
  }

  connect() {
    this.showingSource = !this.sourceTarget.classList.contains("d-none")
    if (this.showingSource) this.loadViewer()
    this.updateButton()
    this.updateScrollContainer()
  }

  toggle() {
    this.showingSource = !this.showingSource

    this.detailsTarget.classList.toggle("d-none", this.showingSource)
    this.sourceTarget.classList.toggle("d-none", !this.showingSource)

    if (this.showingSource) this.loadViewer()

    this.updateButton()
    this.updateUrl()
    this.updateScrollContainer()
  }

  loadViewer() {
    if (this.viewerLoaded) return
    this.viewerLoaded = true

    if (this.hasPdfViewerOutlet) {
      this.pdfViewerOutlet.load()
    }
  }

  updateButton() {
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.toggle("border-primary", this.showingSource)
      this.buttonTarget.classList.toggle("text-primary", this.showingSource)
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-toggle-on", this.showingSource)
      this.iconTarget.classList.toggle("fa-toggle-off", !this.showingSource)
    }
  }

  updateScrollContainer() {
    document.body.classList.toggle("pdf-viewer-active", this.showingSource)
  }

  showHighlight(event) {
    event.preventDefault()

    const { page, pdfSearch } = event.currentTarget.dataset

    if (!this.showingSource) {
      this.showingSource = true
      this.detailsTarget.classList.toggle("d-none", true)
      this.sourceTarget.classList.toggle("d-none", false)
      this.updateButton()
      this.updateScrollContainer()
    }

    if (this.hasPdfViewerOutlet) {
      this.pdfViewerOutlet.navigate({
        page: parseInt(page) || 1,
        search: pdfSearch || ""
      })
    }

    this.updateUrl()
  }

  updateUrl() {
    const url = new URL(window.location.href)

    if (this.showingSource) {
      url.searchParams.set(this.paramValue, "source")
    } else {
      url.searchParams.delete(this.paramValue)
    }

    window.history.replaceState({}, "", url)
  }
}
